import { ElementType } from 'bom/enums';
import { IBomPart, IUpsertBomComponentsPayload } from 'bom/types';

import { ActionType } from './enums';
import { ICopyMoveToElementData } from './types';

export const mapCopyMoveToElementData = (
  data: ICopyMoveToElementData,
  bomParts: IBomPart[],
  actionType: ActionType
): IUpsertBomComponentsPayload => {
  const components = [];

  bomParts.forEach((bomPart, index) => {
    const componentData = {
      id: bomPart.componentId,
      addToElements: [],
      moveToElements: [],
    };

    const bomPartComponentData = data.componentData[index];

    if (!bomPartComponentData.isValid) {
      return;
    }

    const componentElementData = {
      quantity: bomPartComponentData.quantity,
      quantityUomSourceCompanyId: bomPart.costUomSourceCompanyId,
      quantityUom: bomPart.costUom,
      originalUom: bomPart.uom,
    };

    if (actionType === ActionType.COPY) {
      componentData.addToElements.push({
        ...componentElementData,
        id: data.element.id,
      });

      delete componentData.moveToElements;
    } else {
      bomPart.elements.forEach((element) => {
        if ([ElementType.ID_OVERAGE, ElementType.ID_SHORTAGE].includes(element.id as ElementType)) {
          return;
        }

        componentData.moveToElements.push({
          ...componentElementData,
          sourceId: element.id,
          destinationId: data.element.id,
        });
      });

      delete componentData.addToElements;
    }

    components.push(componentData);
  });

  return { components };
};
